import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TextSizes, TextType } from 'src/app/shared/enums';
import { befreeUrlValues, wordDeclensions } from 'src/app/shared/constants';
import { IPhotoReport } from 'src/app/shared/services/photo-reports/photo-reports.type';
import { UtilsService } from 'src/app/shared/services/utils.service';

import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';
import { TextComponent } from '../text/text.component';
import { DateFormatPipe } from '../../pipe/date-format/date-format.pipe';
import { WordDeclensionPipe } from '../../pipe/word-declension/word-declension.pipe';
@Component({
  selector: 'app-photo-report-card',
  templateUrl: './photo-report-card.component.html',
  styleUrls: ['./photo-report-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, RouterLink, TextComponent, DateFormatPipe, WordDeclensionPipe],
})
export class PhotoReportCardComponent {
  utils = inject(UtilsService);

  @Input() photoReport?: IPhotoReport;

  readonly TextSizes = TextSizes;

  readonly TextType = TextType;

  readonly imgDeclension = wordDeclensions.img;

  get reportPageUrl() {
    return `/${befreeUrlValues.dashboard}/${befreeUrlValues.photoreports}/${befreeUrlValues.page}/${this.photoReport?.id}`;
  }
}
